/* istanbul ignore file */
import { Link } from 'react-router-dom';
import { ShowDate } from 'framework/ui/ui-builder';
import { DATE_FORMAT } from 'framework/utils';
import { useOneStopRequestsUrl } from 'domain/shared/oneStop';
import { Box, Typography } from '@mui/material';

interface OneStopRequestProps {
  isDescriptionVisible: boolean;
  description: string;
  id: string;
  shortDescription: Nullable<string>;
  title: string;
  lastUsedAt?: string;
}

const OneStopRequest = ({
  isDescriptionVisible,
  description,
  id,
  shortDescription,
  title,
  lastUsedAt,
}: OneStopRequestProps) => {
  const { getSingleEntityUrl } = useOneStopRequestsUrl();
  const requestUrl = getSingleEntityUrl(id);

  return (
    <Box
      component="li"
      key={id}
      sx={{
        '&:not(:last-child)': {
          marginBottom: '16px',
          paddingBottom: '16px',
          borderBottom: '1px solid',
          borderColor: 'border.separator',
        },
      }}
    >
      <>
        <Typography component={Link} variant="h4" to={requestUrl} color="primary">
          {`${id}. ${title}`}
        </Typography>
        {isDescriptionVisible && (shortDescription || description) && (
          <Typography variant="body1" color="textSecondary" mt={0.75} width="100%" flexGrow={1}>
            {shortDescription || description}
          </Typography>
        )}
      </>
      {lastUsedAt && (
        <Typography component="span" variant="subtitle2" mt="0.6" ml="auto" p={0} color="textSecondary" flexShrink={0}>
          <ShowDate dateUTC={lastUsedAt} format={DATE_FORMAT.FULL} />
        </Typography>
      )}
    </Box>
  );
};

export default OneStopRequest;
